




"use strict";

import $ from 'jquery';


export default class Ketelkiezer {

    constructor (ketelkiezerHolder) {
        if (!ketelkiezerHolder) {
            return;
        }
        this.holder = ketelkiezerHolder;
        this.ketelKiezerOptions = ketelkiezerHolder.querySelector('.ketelkiezer-opties');
        this.toggleKetelkiezerBtn = ketelkiezerHolder.querySelector('.toggle-ketelkiezer');

        if ( this.ketelKiezerOptions ) {
            this.steps = this.ketelKiezerOptions.querySelector('.steps');
            this.options = this.ketelKiezerOptions.querySelectorAll('.steps input[type="radio"]');
            this.stepNav = this.ketelKiezerOptions.querySelectorAll('.step-nav .step-btn');

            this.currentIndex = 0;

            this.addEvents();
        } else {
            this.holder.querySelectorAll('.selection')
                .forEach(select => this.setHiddenField(select));

            this.holder.querySelectorAll('.selection')
                .forEach(select => select.addEventListener('change',
                    () => this.setHiddenField(select)));
        }

        if ( this.holder.dataset.load ) {
            this.toggleKetelkiezer();
        }
    }


    addEvents () {
        // Toggle ketelkiezer
        this.toggleKetelkiezerBtn
            .addEventListener('click',
            () => this.toggleKetelkiezer());

        // Step navigation
        this.stepNav.
            forEach(btn =>
                btn.addEventListener('change',
                () => this.setStep(btn.value)));

        // Options
        this.options.forEach(option => {
            option.checked = false;
            option.addEventListener('change',
                (evt) => this.toggleOption(evt.currentTarget));
        });
    }


    get currentIndex () {
        return this.index;
    }
    set currentIndex (index) {
        this.enableInputs();
        this.index = index;
        if ( this.stepNav.length === index ) {
            this.ketelKiezerOptions.submit();
        } else {
            this.setStepsPosition();
            this.setStepNav();
        }

    }

    disableInputs () {
        this.options.forEach(option => option.disabled = true);
    }
    
    enableInputs () {
        this.options.forEach(option => option.disabled = false);
    }

    setStep (index) {
        this.currentIndex = parseInt(index);
    }

    setStepNav () {
        this.stepNav.forEach(btn =>
            (this.currentIndex == btn.value)
            ? btn.checked = true : btn.checked = false);
    }

    toggleKetelkiezer () {
        this.holder.classList.toggle('active');
        $(this.ketelKiezerOptions).slideToggle();
    }

    toggleOption (option) {
        this.disableInputs();
        this.setHiddenField(option);
        window.setTimeout(() => this.currentIndex += 1, 400);
    }

    setStepsPosition () {
        const currentPos = this.currentIndex * 33.33;
        this.steps.style.transform = `translateX(-${currentPos}%)`;
    }

    setHiddenField(option) {
        const sName = 'w-' + option.dataset.name;
        const sValue = option.value;

        document.querySelector(`input[name="${sName}"]`).value = sValue;
    }

}
